



import React, { useState, useEffect } from 'react';
import {
    getAllDeliveryOrders,
    getDeliveryOrderById
} from "../../../Servicefile/ordermanagementservice.jsx";
// Inline loader hook (same as Userdetails component)
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

// Loader Component (same as Userdetails component)
const Loader = ({ loading, fadeOut, text = "Loading..." }) => {
    if (!loading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.95)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999999,
            transition: 'opacity 0.4s ease',
            fontFamily: 'Arial, sans-serif',
            opacity: fadeOut ? 0 : 1,
            pointerEvents: fadeOut ? 'none' : 'auto'
        }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{
                    fontSize: '2rem',
                    fontWeight: 900,
                    letterSpacing: '6px',
                    marginBottom: '30px',
                }}>
                    {"MAAMAAS".split("").map((l, i) => (
                        <span
                            key={i}
                            style={{
                                display: 'inline-block',
                                opacity: 0,
                                transform: 'translateY(30px)',
                                animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                color: '#e50914',
                            }}
                        >
                            {l}
                        </span>
                    ))}
                </div>

                <div style={{
                    width: '280px',
                    height: '4px',
                    background: 'rgba(255,255,255,0.2)',
                    overflow: 'hidden',
                    margin: '0 auto',
                }}>
                    <div style={{
                        width: '40%',
                        height: '100%',
                        background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                        animation: 'progress 1.8s infinite',
                    }}></div>
                </div>

                <div style={{
                    marginTop: '20px',
                    color: '#aaa',
                    fontSize: '14px',
                }}>
                    {text}
                </div>
            </div>
        </div>
    );
};

const Logisticsorders = () => {
    const [showDetails, setShowDetails] = useState({});
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cancelLoading, setCancelLoading] = useState({});

    // Use inline loader (same as Userdetails component)
    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();

    const isMobile = window.innerWidth < 768;

    // =================== Static Data ===================
    // Keeping this as fallback data
    const staticOrders = [

    ];

    // UPDATED: Changed order stages to 3 stages
    const orderStages = ["Order accepted", "Order onthe way", "Order delivered"];

    const styles = {
        card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)" },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
        orderId: { margin: 0, fontWeight: "bold" },
        date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
        pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold" },
        cancelBtn: {
            background: '#dc3545',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            cursor: 'pointer',
            borderRadius: '5px',
            fontWeight: "bold",
            marginLeft: '10px'
        },
        tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
        statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
        arrow: { margin: '0 5px' },
        dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' },
    };

    // Fetch orders from API
    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {

        try {

            setLoading(true);

            showLoader();

            const token =
                localStorage.getItem("authToken");

            const data =
                await getAllDeliveryOrders(token);

            const filteredData =
                Array.isArray(data)
                    ? data.filter(
                        item =>
                            item.status !== "DELIVERED" &&
                            item.status !== "REJECTED"
                    )
                    : [];

            const transformedOrders =
                filteredData.map(apiOrder => ({
                    orderId:
                        apiOrder.orderId ||
                        apiOrder.id,

                    order: [
                        {
                            dishName:
                                apiOrder.items ||
                                "Delivery",

                            quantity:
                                apiOrder.deliveryAddress ||
                                "Address",

                            to: "Delivery",

                            price:
                                apiOrder.earning || 0,

                            status: "Okay",
                        },
                    ],

                    orderDateAndTime:
                        apiOrder.createdAt ||
                        new Date().toISOString(),

                    status:
                        apiOrder.status ||
                        "OFFERED",

                    apiData: apiOrder,
                }));

            setOrders(transformedOrders);

        } catch (err) {

            console.error(
                "Error fetching orders:",
                err
            );

        } finally {

            setLoading(false);

            hideLoader();
        }
    };

    // Fetch order by ID
    const fetchOrderById = async (orderId) => {

        try {

            const token =
                localStorage.getItem("authToken");

            // 🔥 SERVICE API
            const data =
                await getDeliveryOrderById(
                    orderId,
                    token
                );

            return data;

        } catch (err) {

            console.error(
                "Error fetching order by ID:",
                err
            );

            return null;
        }
    };

    // Cancel/Reject order
    const handleCancelOrder = async (orderId) => {
        if (!window.confirm("Are you sure you want to reject this order?")) return;

        try {
            setCancelLoading(prev => ({ ...prev, [orderId]: true }));

            const token = localStorage.getItem("authToken");

            const order = orders.find(o => o.orderId === orderId);
            if (!order || !order.apiData) {
                throw new Error("Order data not available");
            }

            const partnerId =
                order.apiData.partnerId ||
                order.apiData.deliveryPartnerId;

            if (!partnerId) {
                throw new Error("Partner ID not found");
            }

            // ✅ SINGLE-LINE URL (NO SPACES)
            const url = `https://backend.maamaas.com/delivery/api/update/offer/status?offerId=${orderId}&partnerId=${partnerId}&vendorOtp=1&userOtp=1&status=REJECTED`;

            const response = await fetch(url, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Reject API failed (${response.status})`);
            }

            // ✅ Remove order from UI
            setOrders(prev => prev.filter(o => o.orderId !== orderId));

            alert("Order rejected successfully");
        } catch (err) {
            console.error(err);
            alert(err.message);
        } finally {
            setCancelLoading(prev => ({ ...prev, [orderId]: false }));
        }
    };



    // Refresh orders function
    const handleRefresh = () => {
        fetchOrders();
    };

    return (
        <div className="container-fluid">
            {/* Global Loader (same as Userdetails component) */}
            <Loader loading={globalLoading} fadeOut={fadeOut} text="Loading logistics orders..." />

            {/* Add loader animations to existing style */}
            <style>{`
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }

                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
            `}</style>

            <div className="row">
                <div className="col-lg-11" style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}>
                    {/* Refresh Button */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px' }}>
                        <button
                            onClick={handleRefresh}
                            style={{
                                background: 'rgb(230 109 51)',
                                color: '#fff',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span>Refresh Orders</span>
                        </button>
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <p>Loading orders...</p>
                        </div>
                    ) : error ? (
                        <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
                            <p>Error: {error}</p>
                            <p>Showing static data...</p>
                        </div>
                    ) : (
                        orders.map((order) => {
                            const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
                            const orderId = order.orderId || order.cartId;
                            const isCancelled = order.status === 'REJECTED';

                            return (
                                <div key={orderId} style={styles.card}>
                                    <div style={styles.header}>
                                        <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {/* <button style={styles.pickupBtn}>
                                                {order.service || order.orderType || 'Service'}
                                            </button> */}

                                            {/* Reject Button - Only show if not already rejected */}
                                            {!isCancelled && (
                                                <button
                                                    style={styles.cancelBtn}
                                                    onClick={() => handleCancelOrder(orderId)}
                                                    disabled={cancelLoading[orderId]}
                                                >
                                                    {cancelLoading[orderId] ? 'Rejecting...' : 'Reject'}
                                                </button>
                                            )}

                                            <button
                                                style={styles.dropdownBtn}
                                                onClick={() =>
                                                    setShowDetails((prev) => ({
                                                        ...prev,
                                                        [orderId]: !prev[orderId],
                                                    }))
                                                }
                                            >
                                                {showDetails[orderId] ? '▲' : '▼'}
                                            </button>
                                        </div>
                                    </div>

                                    {showDetails[orderId] && (
                                        <>
                                            <p style={styles.date}>
                                                {order.orderDateAndTime ? (() => {
                                                    const dateObj = new Date(order.orderDateAndTime);
                                                    const date = dateObj.toLocaleDateString('en-IN', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                    });
                                                    const time = dateObj.toLocaleTimeString('en-IN', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: true,
                                                    });
                                                    return (
                                                        <>
                                                            <span style={{ color: 'black' }}>Date: </span>
                                                            <span style={{ color: 'white' }}>{date}</span>
                                                            <br />
                                                            <span style={{ color: 'black' }}>Time: </span>
                                                            <span style={{ color: 'white' }}>{time}</span>
                                                        </>
                                                    );
                                                })() : 'N/A'}
                                            </p>

                                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: 'rgb(230 109 51)', textAlign: 'center' }}>
                                                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
                                                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>Vehicle</th>
                                                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>From</th>
                                                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>To</th>
                                                        <th style={{ padding: '8px', border: '1px solid #ddd' }}>Earning</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orderItems.map((item, index) =>
                                                        item.status === "Okay" || item.orderType === "TABLE_DINE_IN" ? (
                                                            <tr key={index} style={{ borderBottom: '1px solid #eee', fontWeight: 'bold', backgroundColor: '#d4edda' }}>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.dishName}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.quantity || 1}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.to}</td>
                                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>₹{item.price}</td>
                                                            </tr>
                                                        ) : null
                                                    )}
                                                </tbody>
                                            </table>

                                            {/* Additional API Data Display */}
                                            {order.apiData && (
                                                <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                                    <h4 style={{ marginBottom: '8px', color: 'rgb(230 109 51)' }}>Delivery Details</h4>
                                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
                                                        {order.apiData.userName && (
                                                            <div>
                                                                <strong>User:</strong> {order.apiData.userName} ({order.apiData.userPhone})
                                                            </div>
                                                        )}
                                                        {order.apiData.vendorRestaurentname && (
                                                            <div>
                                                                <strong>Vendor:</strong> {order.apiData.vendorRestaurentname}
                                                            </div>
                                                        )}
                                                        {order.apiData.deliveryDistanceKm && (
                                                            <div>
                                                                <strong>Distance:</strong> {parseFloat(order.apiData.deliveryDistanceKm).toFixed(2)} km
                                                            </div>
                                                        )}
                                                        {order.apiData.status && (
                                                            <div style={{ color: order.apiData.status === 'REJECTED' ? '#dc3545' : 'inherit' }}>
                                                                <strong>Status:</strong> {order.apiData.status}
                                                            </div>
                                                        )}
                                                        {order.apiData.vehicleStatus && (
                                                            <div>
                                                                <strong>Vehicle:</strong> {order.apiData.vehicleStatus}
                                                            </div>
                                                        )}
                                                        {order.apiData.deliveryPartnerName && (
                                                            <div>
                                                                <strong>Delivery Partner:</strong> {order.apiData.deliveryPartnerName}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    <div style={{ ...styles.tracker, display: 'flex', justifyContent: 'center', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '5px' : '0px', alignItems: 'center' }}>
                                        {orderStages.map((stage, index) => {
                                            // UPDATED: Map API statuses to new 3-stage order tracking
                                            const statusToStage = {
                                                OFFERED: "Order accepted",
                                                ACCEPTED: "Order accepted",
                                                BEING_PREPARED: "Order onthe way",
                                                ORDER_IS_READY: "Order onthe way",
                                                WAITING_FOR_PICKUP: "Order onthe way",
                                                PICKED_UP: "Order onthe way",
                                                ON_THE_WAY: "Order onthe way",
                                                DELIVERED: "Order delivered",
                                                COMPLETED: "Order delivered",
                                                PROCESSING: "Order accepted",
                                                REJECTED: "Order accepted", // Rejected orders show only first stage
                                            };

                                            let isActive = false;
                                            if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
                                                const relevantStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
                                                const itemStageIndexes = order.cartItems
                                                    .filter(item => relevantStatuses.includes(item.orderStatus))
                                                    .map(item => orderStages.indexOf(statusToStage[item.orderStatus] || "Order accepted"))
                                                    .filter(i => i !== -1);
                                                const highestStageIndex = itemStageIndexes.length > 0 ? Math.max(...itemStageIndexes) : 0;
                                                isActive = index <= highestStageIndex;
                                            } else {
                                                // For rejected orders, only show the first stage
                                                if (order.status === 'REJECTED') {
                                                    isActive = index === 0;
                                                } else {
                                                    const currentStageIndex = orderStages.indexOf(statusToStage[order.status] || "Order accepted");
                                                    isActive = index <= currentStageIndex;
                                                }
                                            }

                                            return (
                                                <React.Fragment key={index}>
                                                    <div style={{
                                                        ...styles.statusBox,
                                                        backgroundColor: isActive ? (order.status === 'REJECTED' && index === 0 ? "#dc3545" : "green") : "#f0f0f0",
                                                        color: isActive ? "white" : "black",
                                                        borderRadius: "6px",
                                                        padding: "8px 12px",
                                                        fontWeight: "bold",
                                                        textTransform: "uppercase",
                                                        transition: "0.3s"
                                                    }}>
                                                        {order.status === 'REJECTED' && index === 0 ? 'REJECTED' : stage}
                                                    </div>
                                                    {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default Logisticsorders;